import React from 'react'
import { Link } from 'react-router-dom'

export default function Grapes() {
  return  <>
     <div className="container-fluid bg-primary py-5 bg-prd7 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Grapes </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Grapes </Link>
          </div>
        </div>
      </div>
    </div>

  <div className="container py-5">
    <div className='mb-5'>
      <h2 className='text-primary'> Grapes</h2>
      <h5 className='text-muted'> Grapes are the fruit of the grapevine and come in various colors and sizes, such as green, red, and black.
  <br />Grapes are a primary source for wine production.

      </h5>
    </div>
    <h2 className='text-primary my-3'>Nutritional Composition:
</h2>

    <ul className='mb-5'>
      <li className="my-2">
        <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Grapes contain high water content and natural sugars.</h5>
      </li>
      <li className="my-2">
        <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>They provide vitamin C, B-group vitamins, and antioxidants like resveratrol.</h5>
      </li>

    </ul>

    <hr />
    <hr />
    <h2 className='text-primary my-3'>Season:</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Egypt, typically run from end May to October. 
    </h5>
  </li>


</ul>
<hr />

<h2 className='text-primary my-3'>Packing</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>in 6 kgs net weight cartons or plastic 
punnet carton: 5 kg net weight per carton, with each carton holding 10 punnets of 
500 g. there are 3,600 cartons in total, distributed across 20 pallets, each pallet 
containing 180 cartons.
    </h5>
  </li>
 
</ul>

<hr />
    <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

  </div>
</>
}
